<div class="user_dropdown_class">
  <div class="control-wrapper">
    @for (user of userValues; track user) {
      <div>
        <button
          [attr.data-testid]="'user-popover-user-button-' + $index"
          title="{{ user.userName }}"
          [id]="user.userUuid"
          [value]="user"
          (click)="selectUser(user)"
          class="text-truncate dropdown-item"
          >
          {{ user.userName }}
        </button>
      </div>
    }
  </div>